/** Count declared source keys only. Does not infer linguistic review from equality. */
export function catalogCoverage(source: Readonly<Record<string, string>>, localized: Readonly<Partial<Record<string, string>>>) {
  const keys = Object.keys(source);
  const missing = keys.filter(key => !localized[key]?.trim());
  return { total: keys.length, present: keys.length - missing.length, missing };
}
